import { use_slice_ui } from '@/hooks/store/use_slices';
import { path_relative_to_absolute } from '@/utils/utils_files_client';

export function G_OVERLAY__image_preview() {
  const { g_output__image_asset_preview } = use_slice_ui(['g_output__image_asset_preview']);

  if (g_output__image_asset_preview.is_stub()) return null;

  const url_absolute = path_relative_to_absolute(g_output__image_asset_preview.url_relative_latest);

  return (
    <div className="absolute inset-0 size-full bg-bar">
      <img className="nodrag size-full max-w-full max-h-full object-contain  rounded" src={url_absolute} />
    </div>
  );
}
